import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import SearchInput from './SearchInput';
import AttendeesTable from './AttendeesTable';

const Attendees = ({ attendances }) => (
  <div className="EventSessionOverview-attendees mb-32">
    <h2 className="ff-ss mb-16">
      {t('in_person_training.event_overview.attendances.all_attendees')} (
      {attendances.length})
    </h2>
    <SearchInput />
    {!isEmpty(attendances) && <AttendeesTable />}
  </div>
);

const mapStateToProps = state => ({
  attendances: state.attendances,
});

export default connect(mapStateToProps)(Attendees);
